"use strict";
import { formScrollerInit, formValidate } from "../../utility/_form";

window.addEventListener("DOMContentLoaded", () => {
  formScrollerInit();
  formValidate();
});
